import React, { useEffect, useState, useRef } from 'react';

import { LangText } from "../zustand/dict.js";

import images from '../libs/images';
import consts from '../libs/consts';

import { clickDownS3, getFileName, regFileDoc, regFileImage, regFileVideo } from '../utils/utils';

import Button from './Button';
import Image from './Image';

import { toast } from 'react-toastify';
import { useLang } from '../zustand/store.js';

export default function InputFileDrag(props) {
    const {
        name,
        style,
        type = "file",
        valid = "image",
        value,
        setValue,
        onMetaData = () => { },
        onChange,
        setExt,
        setFileName,
        readOnly,
        onDelete,
        limit,
    } = props;

    const fileInput = useRef();
    const { getLang } = useLang()
    const [isDragging, setIsDragging] = useState(false);

    const [detailImageUrl, setDetailImageUrl] = useState("");
    const [file_name, setfile_name] = useState("");

    const makeVideoThumb = (video) => {
        let canvas = document.createElement('canvas');
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;

        let ctx = canvas.getContext('2d');
        ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

        const dataUri = canvas.toDataURL();
        let base64Mark = "base64,"
        let dataStart = dataUri.indexOf(base64Mark) + base64Mark.length;
        let resultStr = dataUri.substring(dataStart);

        return dataUri
    }

    const onAddFiles = (file) => {
        var reg = "";
        var msg = "";
        let video = null;

        if (valid === 'image') {
            reg = regFileImage;
            msg = "이미지";
        } else if (valid === 'doc') {
            reg = regFileDoc;
            msg = "문서";
        } else if (valid === 'video') {
            setDetailImageUrl("");
            onMetaData("null");

            if (limit && typeof limit == "number") {
                if (file.size > limit) {
                    setDetailImageUrl("");
                    onMetaData("null");
                    fileInput.current.value = "";
                    toast.error(
                        getLang({ key: "error_video_oversize" }), consts.toastErrorOption
                    );
                    return
                }
            }

            reg = regFileVideo;
            msg = "비디오";

            video = document.createElement('video')
            video.preload = "auto"

            video.oncanplay = () => {
                let imgData = makeVideoThumb(video)
                if (imgData) {
                    setDetailImageUrl(imgData)
                }
            }

            video.addEventListener('loadedmetadata', event => {
                console.log("video width,height:", video.videoWidth, video.videoHeight);
                // When the metadata is loaded, duration can be read.
                onMetaData({
                    width: video.videoWidth,
                    height: video.videoHeight,
                    duration: video.duration
                })
            });

            video.addEventListener('error', event => {
                onMetaData(null);
                fileInput.current.value = "";
            });
        }
        // console.log("file.name", file.name)
        if (file.name.toLowerCase().match(reg)) {
            setfile_name(file.name);

            if (setFileName) setFileName(file.name);

            let reader = new FileReader();
            reader.onload = function () {

                let fn = file.name.split('.');

                if (onChange) {
                    onChange(reader.result, fn[fn.length - 1]);
                } else {
                    setDetailImageUrl(reader.result);
                    if (video) video.src = reader.result;
                    setValue({
                        base: reader.result,
                        ext: fn[fn.length - 1]
                    });

                    if (setExt) {
                        setExt(fn[fn.length - 1]);
                    }
                }
            };
            reader.readAsDataURL(file);
            fileInput.current.value = "";

        } else {

            fileInput.current.value = "";

            if (!onChange) {
                setValue("");
                setDetailImageUrl("");
                setfile_name("");

                if (setFileName) setFileName("");
                if (setExt) {
                    setExt('');
                }
            }

            toast.error(
                getLang({ key: "error_video_format" }), consts.toastErrorOption
            );
        }


    };

    // set file reader function
    const fileDelete = () => {
        if (!readOnly) {
            fileInput.current.value = "";
            setValue("");
            setDetailImageUrl("");
            setfile_name("");

            onDelete && onDelete();
        }
    };

    useEffect(() => {
        if (!detailImageUrl && value) {
            console.log("🚀 ~ useEffect ~ value:", value)
            setDetailImageUrl(value.base);
            setfile_name("Previously uploaded files");
        }
    }, [value])

    return (
        <div
            style={style}
            className={`input_drag_box ${isDragging && "focus"}`}
            onDragEnter={(e) => {
                e.preventDefault();
                e.stopPropagation();
                setIsDragging(true);
            }}
            onDragOver={(e) => {
                e.preventDefault();
                e.stopPropagation();
                setIsDragging(true);
            }}
            onDragLeave={(e) => {
                e.preventDefault();
                e.stopPropagation();
                setIsDragging(false);
            }}
            onDrop={(e) => {
                e.preventDefault();
                e.stopPropagation();
                setIsDragging(false);
                let files = e.dataTransfer.files
                if (files.length) {
                    onAddFiles(files[0])
                }
            }}
        >

            <div className='darg_info_box'>
                <label style={{ textAlign: "center" }} className='pointer' htmlFor={name}>
                    <img src={images.upload_file_big} />
                    <p className='body1 mt-8'><LangText id={"text_dragndrop"} /></p>
                    <p className='body1 mt-4'>
                        <LangText id={"text_or"} />&nbsp;
                        <span className='color-sec'><LangText id={"btn_upload_file"} /></span>
                        {/* <label className='color-sec pointer' htmlFor={name}>
                        <LangText id={"btn_upload_file"} />
                    </label> */}
                    </p>
                </label>
            </div>
            {
                detailImageUrl && <div className="file_info_box">
                    <div className="file_info">
                        {valid === 'image' ? <img className='drag_files' src={detailImageUrl ? detailImageUrl : images.profile} /> :
                            <img className='drag_files' src={images.slow_video} />
                        }

                        <p className='body1'>{file_name.length > 20 ? file_name.substring(0, 20) + "..." : file_name}</p>
                    </div>
                    <img className="pointer" src={images.icon_x} onClick={() => { fileDelete(); }} />
                </div>
            }
            <input
                style={{
                    display: "none"
                }}
                ref={fileInput}
                type={type}
                name={name}
                id={name}
                onChange={({ target: { files } }) => {
                    if (files.length) {
                        onAddFiles(files[0])
                    }
                }} />
            {/* {isDragging && <div className='darg_bg'></div>} */}
        </div>
    )
}